import React, {FC} from 'react';
import {Controller} from 'react-hook-form';
import {
	IToggleProps,
	StackCompat as Stack,
	TextCompat as Text,
	ToggleCompat as Toggle,
} from 'components/FluentUICompat';
import {HookFormProps} from '../HookFormProps';
import {ControlledToggleLabelWithTooltip} from './ControlledToggleLabel';
import {LabelWithTooltipProps} from 'features/localizedTooltips';

type ControlledToggleProps = Omit<IToggleProps, 'defaultValue'> &
	Pick<LabelWithTooltipProps, 'tooltipHostProps'> &
	HookFormProps & {
		placeholder?: string;
	};

export const ControlledToggle: FC<ControlledToggleProps> = props => {
	return (
		<Controller
			name={props.name}
			control={props.control}
			rules={props.rules}
			defaultValue={props.defaultValue || false}
			render={({field: {onChange, onBlur, value}}) => (
				<Toggle
					{...props}
					onChange={(e, val) => {
						onChange(Boolean(val));
						props.onChange?.(e, val);
					}}
					checked={value || false}
					onBlur={onBlur}
					label={
						<Stack>
							<ControlledToggleLabelWithTooltip
								name={props.name}
								label={props.label}
								tooltipHostProps={props.tooltipHostProps}
							/>
							{props?.placeholder && (
								<Text style={{opacity: '0.8', paddingTop: 5}}>
									{props?.placeholder}
								</Text>
							)}
						</Stack>
					}
				/>
			)}
		/>
	);
};
